import SendIcon from '@atlaskit/icon/core/send';
import * as React from 'react';

export function SvgSend() {
  return <SendIcon label="" testId="ads-refreshed-icon" />;
}
